import { useEffect, useState } from 'react';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';

import { mapAlgoliaProductToProduct } from '../../shared/algoliaHelpers';
import { type ProductSearchItem } from '../../shared/types';
import { type AlgoliaProduct } from '../types/types';

type UseRelatedProductsReturn = {
    products: ProductSearchItem[];
    status: 'idle' | 'loading' | 'stalled' | 'error';
    hasNoResults: boolean;
    hasRelatedProducts: boolean;
    isLastPage: boolean;
    showMore: () => void;
};

export function useRelatedProducts(): UseRelatedProductsReturn {
    const { status } = useInstantSearch({ catchError: true });
    const { items, results, isLastPage, showMore } = useInfiniteHits<AlgoliaProduct>();
    const products = items.map(item => mapAlgoliaProductToProduct(item)) || [];
    const nbItems = results?.nbHits || 0;
    const hasNoResults = !results?.__isArtificial && nbItems === 0;
    const [hasRelatedProducts, setHasRelatedProducts] = useState<boolean>(
        !hasNoResults && nbItems > 0,
    );

    useEffect(() => {
        if (!hasRelatedProducts) {
            setHasRelatedProducts(nbItems > 0);
        }
    }, [nbItems]);

    return {
        products,
        status,
        hasNoResults,
        showMore,
        isLastPage,
        hasRelatedProducts,
    };
}
